import {
    Service
  } from './index'
  //登入
  export function loginIn(data) {
    return Service({
      url: '/amall_oauth/login',
      method: 'post',
      data: data
    })
  } 
  //修改密码

export function update_password(data) {
    return Service({
      url: '/amall_user/shop/forgetPassword',
      method: 'post',
      data: data
    })
  } 


// WEBPACK FOOTER //
// ./src/service/login.js